import { Button } from "antd";
import { ButtonProps } from "antd/lib";
import * as React from "react";
import { SlidersIcon } from "src/icons";

import { RtCtrlColumnsSettings } from "../../ctrl";
import { RtColumnsSettingsModal } from "./RtColumnsSettingsModal";

type PropsRtColumnsSettings = {
  store: RtCtrlColumnsSettings;
  size?: ButtonProps["size"];
  tooltip?: string;
};

export const RtColumnsSettingsButton: React.FC<PropsRtColumnsSettings> = (
  props,
) => {
  const {
    store,
    size = "middle",
    tooltip = "Настройка колонок таблицы",
  } = props;
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <Button
        type="text"
        size={size}
        icon={<SlidersIcon />}
        title={tooltip}
        onClick={() => setOpen(true)}
      />
      <RtColumnsSettingsModal
        store={store}
        open={open}
        close={() => setOpen(false)}
      />
    </>
  );
};
